document.addEventListener('DOMContentLoaded', function () {
	const icons = document.querySelectorAll('.social-media-icon');

	// Sprawdzenie, czy urządzenie ma ekran dotykowy
	const isTouchDevice =
		'ontouchstart' in window || navigator.maxTouchPoints > 0;
	if (isTouchDevice) return;

	let tooltip = document.createElement('div');
	tooltip.className = 'tooltip';
	document.body.appendChild(tooltip);

	icons.forEach((icon) => {
		icon.addEventListener('mouseenter', function () {
			tooltip.innerText = icon.getAttribute('data-tooltip');
			tooltip.style.opacity = '1';
		});

		icon.addEventListener('mousemove', function (e) {
			tooltip.style.left = `${e.pageX + 10}px`;
			tooltip.style.top = `${e.pageY + 10}px`;
		});

		icon.addEventListener('mouseleave', function () {
			tooltip.style.opacity = '0';
		});
	});
});
